<div class="d-flex" style="margin-bottom: 24px">
    <div class="border-dashed rounded text-center total-box" style="margin-right: 20px">
        <div class="total-number" style="margin: 17px 28px">
            <span class="texte-clair text-center">Retenue à la source *</span>
            <div class="d-flex" style="margin-top: 16px">
                <div class="flex-grow-1 cursor-pointer d-flex align-items-center">
                    <input
                            type="radio"
                            id="non-retenue"
                            value="non"
                            name="retenue"
                            [(ngModel)]="retenueSelection"
                            (ngModelChange)="onRetenueChange($event)"
                            class="custom-radio"
                    />
                    <label class="size15-400 texte-standard ml-2 mb-0" for="non-retenue">Non</label>
                </div>
                <div class="flex-grow-1 cursor-pointer d-flex align-items-center">
                    <input
                            type="radio"
                            id="oui-retenue"
                            value="oui"
                            name="retenue"
                            [(ngModel)]="retenueSelection"
                            (ngModelChange)="onRetenueChange($event)"
                            class="custom-radio"
                    />
                    <label class="size15-400 texte-standard ml-2 mb-0" for="oui-retenue">Oui</label>
                </div>
            </div>
        </div>
    </div>

    <div class="border-dashed rounded timbre-box" style="margin-right: 20px" *ngIf="valeurRetenue">
        <div class="total-number" style="margin: 16px 28px">
            <span class="texte-clair text-center">Avec timbre fiscal*</span>
            <div class="d-flex align-items-center" style="margin: 8px 0 12px 0;">
                <div class="flex-grow-1 cursor-pointer align-self-center d-flex align-items-center">
                    <input type="radio" id="non-timbre" value="non" name="timbre" [(ngModel)]="timbreSelection" (ngModelChange)="onTimbreChange($event)" class="custom-radio">
                    <label class="size15-400 texte-standard ml-2 mb-0" for="non-timbre">Non</label>
                </div>
                <div class="flex-grow-1 cursor-pointer align-self-center d-flex align-items-center">
                    <input type="radio" id="oui-timbre" value="oui" name="timbre" [(ngModel)]="timbreSelection" (ngModelChange)="onTimbreChange($event)" class="custom-radio">
                    <label class="size15-400 texte-standard ml-2 mb-0" for="oui-timbre">Oui</label>
                </div>
                <div class="table-input" style="width: 160px; align-self: start;">
                    <select class="form-control" [(ngModel)]="tauxRS" (ngModelChange)="onTauxRSChange($event)" title="Taux RS">
                        <option value="1">1%</option>
                        <option value="1.5">1.5%</option>
                        <option value="5">5%</option>
                        <option value="10">10%</option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <div class="border-dashed rounded text-center montant-box" style="margin-right: 20px" *ngIf="valeurRetenue">
        <div class="total-number" style="margin: 17px 28px">
            <p class="texte-bleu text-center">{{ montantRetenue | number:'1.2-2' }} TND</p>
            <p class="texte-2 text-center">Montant TTC</p>
        </div>
    </div>

    <div class="card rounded text-center net-box" *ngIf="valeurRetenue">
        <div class="total-number" style="margin: 14px 28px">
            <p class="texte-bleu text-center">{{ netAPayer | number:'1.2-2' }} TND</p>
            <p class="texte-2 text-center m-0">Net à payer TTC</p>
        </div>
    </div>
</div>

<!-- Conteneur principal pour toutes les sections -->
<div class="border-dashed rounded espece-box" *ngIf="fenetre >= 1">
    <div style="padding-bottom: 24px">
        <div *ngFor="let section of allSections; let i = index">
            <hr *ngIf="i > 0" style="border-bottom: 1px dashed rgba(19, 74, 211, 1); margin: 24px 0 0 0">
            <div class="d-flex align-items-center" style="width: 100%; padding: 24px 37px 0 37px; cursor: pointer;" (click)="toggleContent(section.id)">
                <div class="d-flex align-items-center" style="pointer-events: auto;">
                    <i class="bi" [ngClass]="section.isContentVisible ? 'bi-chevron-down' : 'bi-chevron-right'" style="padding-right: 8px; color: rgba(19, 74, 211, 1)"></i>
                    <p class="texte-noir mb-0 ms-2">#{{ section.id }} {{ section.type === 'espece' ? 'Espèce' : section.type === 'cheque' ? 'Chèque' : section.type === 'virement' ? 'Virement bancaire' : section.type === 'avoir' ? 'Avoir' : 'Traite' }}</p>
                </div>
                <p class="texte-bleu text-center mb-0 flex-grow-1">{{ getSectionMontant(section.id) | number:'1.2-2' }} TND</p>
                <i *ngIf="!isFacturePartiellementPayee()" class="bi bi-trash3 trash ms-auto" (click)="deleteSection(section.id); $event.stopPropagation()"></i>
            </div>

            <div *ngIf="section.isContentVisible" style="padding: 0 37px 0 37px">
                <label class="form-label" style="margin-top: 24px;">Montant<span class="req">*</span></label>
                <input
                        type="number"
                        class="form-control"
                        placeholder="Entrez le montant"
                        name="montant-{{ section.id }}"
                        [(ngModel)]="section.data.montant"
                        (ngModelChange)="updateSectionData(section.id, 'montant', $event); calculateSectionTotal(section.id)"
                        (wheel)="$event.preventDefault()"
                        required
                        step="0.01"
                />
                <div class="items" style="margin-top: 24px" *ngIf="section.type === 'espece' || section.type === 'cheque' || section.type === 'traite'">
                    <div class="form-options rounded col-lg-12 d-flex border-style p-0 flex-wrap">
                        <div
                                class="type d-flex flex-grow-1 cursor-pointer mr-2"
                                style="padding: 16px; min-width: 260px"
                                *ngFor="let solde of soldesList"
                                (click)="onSoldeTypeChange(section.id, solde.type_solde)"
                        >
                            <div class="d-flex">
                                <!-- Radio -->
                                <div style="width: 24px; margin-top: 2px">
                                    <input
                                            type="radio"
                                            id="solde-{{ section.id }}-{{ solde.type_solde }}"
                                            name="solde-{{ section.id }}"
                                            [value]="solde.type_solde"
                                            [checked]="getSectionData(section.id)?.soldeType === solde.type_solde"
                                            class="custom-radio"
                                    >
                                </div>
                                <!-- Texte -->
                                <div>
                                    <p class="size15 mb-0">{{ solde.type_solde }}</p>
                                    <p style="color: rgba(47, 43, 61, 0.7); font-weight: 400; margin-top: 8px">
                                        {{ getSoldeMontantForType(solde.type_solde) }} TND
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="section.type === 'espece'">
                    <label class="form-label" style="margin-top: 24px;">Date de règlement <span class="req">*</span></label>
                    <input
                            type="date"
                            class="form-control"
                            placeholder="Entrez la date de règlement"
                            name="date-reglement-{{ section.id }}"
                            [(ngModel)]="section.data.date_reglement"
                            (ngModelChange)="updateSectionData(section.id, 'date_reglement', $event)"
                            required
                    />
                </div>

                <div *ngIf="section.type === 'cheque'">
                    <label class="form-label" style="margin-top: 24px;">Porteur <span class="req">*</span></label>
                    <input
                            type="text"
                            class="form-control"
                            placeholder="Saisissez le porteur de chèque"
                            name="porteur-{{ section.id }}"
                            [(ngModel)]="section.data.porteur"
                            (ngModelChange)="updateSectionData(section.id, 'porteur', $event)"
                            required
                    />
                </div>

                <div *ngIf="section.type === 'cheque'" class="row" style="margin-top: 24px">
                    <div class="col-6">
                        <label class="form-label">Banque *</label>
                        <select [(ngModel)]="section.data.banque_id" class="form-control" name="banque-{{ section.id }}" (ngModelChange)="updateSectionData(section.id, 'banque_id', $event)">
                            <option value="">Sélectionnez votre banque</option>
                            <option *ngFor="let banque of banques" [value]="banque.id">{{ banque.nom }}</option>
                        </select>
                    </div>
                    <div class="col-6">
                        <label class="form-label">Numéro de chèque <span class="req">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                placeholder="Saisissez le numéro de chèque"
                                name="numero-cheque-{{ section.id }}"
                                [(ngModel)]="section.data.numero_cheque"
                                (ngModelChange)="updateSectionData(section.id, 'numero_cheque', $event)"
                                required
                        />
                    </div>
                </div>

                <div *ngIf="section.type === 'traite'">
                    <label class="form-label" style="margin-top: 24px;">Compte source <span class="req">*</span></label>
                    <input
                            type="text"
                            class="form-control"
                            placeholder="Saisissez compte source"
                            name="compte-source-{{ section.id }}"
                            [(ngModel)]="section.data.compte_source"
                            (ngModelChange)="updateSectionData(section.id, 'compte_source', $event)"
                            required
                    />
                </div>

                <div *ngIf="section.type === 'virement' || section.type === 'traite'" class="mb-3" style="margin-top: 24px">
                    <!-- Alerte toujours affichée -->
                    <ngb-alert [type]="'danger'" [dismissible]="false" class="mb-3">
                        <h4 class="alert-heading">Attention</h4>
                        <div class="alert-body">
                            Si vous ne disposez pas d'un compte bancaire, veuillez en ajouter un.
                        </div>
                    </ngb-alert>
                    
                    <!-- Select pour choisir un compte bancaire -->
                    <div *ngIf="comptesBancaires.length > 0">
                        <label class="form-label" style="margin-bottom: 8px;">Compte bancaire <span class="req">*</span></label>
                        <ng-select
                                [ngModel]="section.data.compte_bancaire_id"
                                (ngModelChange)="updateSectionData(section.id, 'compte_bancaire_id', $event)"
                                [items]="comptesBancaires"
                                bindLabel="nom"
                                bindValue="id"
                                placeholder="Sélectionnez un compte bancaire"
                                [clearable]="false"
                                [searchable]="true"
                                class="compte-bancaire-select"
                                style="width: 100%;">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="compte-option">
                                    <div class="compte-nom">{{ item.nom }}</div>
                                </div>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                                <span class="compte-label">{{ item?.nom }} </span>
                            </ng-template>
                        </ng-select>
                    </div>
                    <!-- Message si aucun compte bancaire disponible -->
                    <div *ngIf="comptesBancaires.length === 0" class="text-muted d-flex align-items-center" style="font-size: 14px; padding: 12px 16px; background-color: #f8f9fa; border-radius: 6px; border: 1px solid #dee2e6;">
                        <i class="bi bi-info-circle me-2" style="font-size: 16px;"></i>
                        <span>Aucun compte bancaire disponible. Veuillez en ajouter un depuis les paramètres.</span>
                    </div>
                </div>

                <div *ngIf="section.type === 'virement'">
                    <label class="form-label" style="margin-top: 24px;">Informations concernant le virement bancaire <span class="req">*</span></label>
                    <input
                            type="text"
                            class="form-control"
                            placeholder="Saisissez les informations du virement"
                            name="info-virement-{{ section.id }}"
                            [(ngModel)]="section.data.informations_virement"
                            (ngModelChange)="updateSectionData(section.id, 'informations_virement', $event)"
                            required
                    />
                </div>

                <div *ngIf="section.type === 'traite'">
                    <label class="form-label" style="margin-top: 24px;">Numéro de la traite <span class="req">*</span></label>
                    <input
                            type="text"
                            class="form-control"
                            placeholder="Saisissez le numéro de traite"
                            name="numero-traite-{{ section.id }}"
                            [(ngModel)]="section.data.numero_traite"
                            (ngModelChange)="updateSectionData(section.id, 'numero_traite', $event)"
                            required
                    />
                </div>

                <div class="row" *ngIf="section.type === 'traite'" style="margin-top: 24px">
                    <div class="col-6">
                        <label class="form-label">Date de règlement <span class="req">*</span></label>
                        <input
                                type="date"
                                class="form-control"
                                placeholder="15/12/2025"
                                name="date-reglement-traite-{{ section.id }}"
                                [(ngModel)]="section.data.date_reglement"
                                (ngModelChange)="updateSectionData(section.id, 'date_reglement', $event)"
                                required
                        />
                    </div>
                    <div class="col-6">
                        <label class="form-label">Date d'échéance <span class="req">*</span></label>
                        <input
                                type="date"
                                class="form-control"
                                placeholder="15/12/2025"
                                name="date-echeance-{{ section.id }}"
                                [(ngModel)]="section.data.date_echeance"
                                (ngModelChange)="updateSectionData(section.id, 'date_echeance', $event)"
                                required
                        />
                    </div>
                </div>

                <div *ngIf="section.type === 'virement'">
                    <label class="form-label" style="margin-top: 24px;">Date de règlement<span class="req">*</span></label>
                    <input
                            type="date"
                            class="form-control"
                            placeholder="Entrez la date de règlement"
                            name="date-virement-{{ section.id }}"
                            [(ngModel)]="section.data.date_reglement"
                            (ngModelChange)="updateSectionData(section.id, 'date_reglement', $event)"
                            required
                    />
                </div>
            </div>

            <div *ngIf="section.isContentVisible && section.type !== 'avoir'" class="step-form d-flex align-items-center justify-content-center text-center w-100 p-0" style="max-width: 933px; margin: 24px 37px 24px 37px">
                <input type="file" #fileInput style="display: none;" (change)="onFileSelected($event, section.id)" accept=".pdf" multiple />
                <div
                        class="form-section rounded border-style"
                        style="text-align: center; cursor: pointer; padding: 24px;"
                        (click)="triggerFileInput($event, section.id)"
                        (dragover)="onDragOver($event)"
                        (drop)="onDrop($event, section.id)"
                        [ngClass]="{
            'default-bg': (getSectionFiles(section.id) || []).length === 0,
            'success-bg': (getSectionFiles(section.id) || []).length > 0
          }"
                >
                    <p style="font-size: 15px; font-weight: 500; color: #2F2B3D; margin: 0;">
                        Déposez les fichiers ici ou cliquez pour télécharger
                    </p>
                    <p style="font-size: 13px; font-weight: 400; color: #6B7280; margin-top: 8px;">
                        Télécharger jusqu'à 10 fichiers (PDF, max 1 Mo chacun)
                    </p>
                    <a class="action-icon" style="color: rgba(19, 74, 211, 1); margin-top: 16px;">
                        <span data-feather="download" [size]="23"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div style="margin: 24px 0">
    <button class="btn boutton-bleu espece bouttonMargin" (click)="toggleEspeceBox()">Espèce</button>
    <button class="btn boutton-bleu bouttonMargin" (click)="toggleChequeBox()">Chèque</button>
    <button class="btn boutton-bleu bouttonMargin" (click)="toggleVirementBox()">Virement bancaire</button>
    <button class="btn boutton-bleu bouttonMargin" (click)="toggleTraiteBox()">Traite</button>
</div>

<!-- Composant pour gérer les comptes bancaires -->
<app-croud-compte-bancaire 
    #croud
    [idStation]="idStation"
    (accountAdded)="onAccountAdded($event)"
    (accountUpdated)="onAccountUpdated($event)">
</app-croud-compte-bancaire>
